import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "labeltitle" }
const _hoisted_2 = { class: "labeltitle" }
const _hoisted_3 = ["readonly"]
const _hoisted_4 = { class: "labeltitle" }
const _hoisted_5 = { class: "labeltitle" }
const _hoisted_6 = { class: "labeltitle" }
const _hoisted_7 = { class: "labeltitle" }
const _hoisted_8 = { class: "labeltitle" }
const _hoisted_9 = { class: "labeltitle" }
const _hoisted_10 = { class: "labeltitle" }
const _hoisted_11 = { class: "labeltitle" }
const _hoisted_12 = { class: "labeltitle" }
const _hoisted_13 = { class: "labeltitle" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("option", {
  value: "M",
  selected: ""
}, " Male", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("option", { value: "F" }, " Female", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("option", { value: "O" }, " Other", -1)
const _hoisted_17 = [
  _hoisted_14,
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = { class: "labeltitle" }
const _hoisted_19 = { class: "labeltitle" }
const _hoisted_20 = { class: "labeltitle" }
const _hoisted_21 = { class: "labeltitle" }
const _hoisted_22 = { class: "labeltitle" }
const _hoisted_23 = { class: "labeltitle" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("option", { value: "CR" }, "CR", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("option", { value: "CT" }, "CT", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("option", { value: "MR" }, "MR", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("option", { value: "US" }, "US", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("option", { value: "DX" }, "DX", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("option", { value: "OT" }, "OT", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("option", { value: "MG" }, "MG", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("option", { value: "SR" }, "SR", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("option", { value: "XA" }, "XA", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("option", { value: "RF" }, "RF", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("option", { value: "NM" }, "NM", -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("option", { value: "PT" }, "PT", -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("option", { value: "ECG" }, "ECG", -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("option", { value: "ES" }, "ES", -1)
const _hoisted_38 = [
  _hoisted_24,
  _hoisted_25,
  _hoisted_26,
  _hoisted_27,
  _hoisted_28,
  _hoisted_29,
  _hoisted_30,
  _hoisted_31,
  _hoisted_32,
  _hoisted_33,
  _hoisted_34,
  _hoisted_35,
  _hoisted_36,
  _hoisted_37
]
const _hoisted_39 = { class: "labeltitle" }
const _hoisted_40 = { class: "labeltitle" }
const _hoisted_41 = { class: "labeltitle" }
const _hoisted_42 = { class: "labeltitle" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("option", { value: "SCHEDULED" }, " Scheduled", -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("option", { value: "INPROGRESS" }, " InProgress", -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("option", { value: "DISCONTINUED" }, " Discontinued", -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("option", { value: "COMPLETED" }, " Completed", -1)
const _hoisted_47 = [
  _hoisted_43,
  _hoisted_44,
  _hoisted_45,
  _hoisted_46
]

import { onMounted, ref } from "vue";
import { useStore } from 'vuex'
import { Worklist } from './Worklist';
import { today, now, DICOM2Date, DICOM2Time } from '../common/routines';


export default /*#__PURE__*/_defineComponent({
  __name: 'WorklistEdit',
  props: ['selectedEntries'],
  emits: ['close'],
  setup(__props, { emit: emits }) {

const props = __props;



const store = useStore();

var wkl = ref( new Worklist());
var title = ref("Edit Worklist Entry");
var editMode = ref(true);

function closeCancel() {
    emits('close');
}

async function closeOk() {
    if(wkl.value.id.length==0){
        alert("Add Worklist ERROR: Accession Number can't be empty");
        return;
    }
    if(editMode.value){
        const result = await store.dispatch('HTTPPut', { url: "worklist/", id: wkl.value.id, object: wkl.value });
        alert(result);
    } else {
        const result = await store.dispatch('HTTPPost', { url: "worklist/", object: wkl.value });
        alert(result);
    }
    emits('close');
}

onMounted(() => {
    if (props.selectedEntries.length>0) {
        if (props.selectedEntries.length > 1) {
            alert("ERROR, only one entry can be selected");
            emits('close');
        } else {
            wkl.value = props.selectedEntries[0];
            wkl.value.date = DICOM2Date(wkl.value.date);
            wkl.value.starttime = DICOM2Time(wkl.value.starttime);
        }
    } else {
        title.value = "Add New Worklist Entry";
        wkl.value.date = today();
        wkl.value.starttime = now();
        wkl.value.patbd = today();
        wkl.value.patsex="M";
        wkl.value.modality = "CR";
        wkl.value.status="SCHEDULED";
        editMode.value = false;
    }
});

return (_ctx: any,_cache: any) => {
  const _component_modal_dialog = _resolveComponent("modal-dialog")!

  return (_openBlock(), _createBlock(_component_modal_dialog, {
    onCloseCancel: closeCancel,
    onCloseOk: closeOk,
    title: _unref(title),
    okBtn: "Accept",
    cnlBtn: "Cancel"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("Study.AccessionNumber")), 1),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(wkl).id) = $event)),
          readonly: _unref(editMode)
        }, null, 8, _hoisted_3), [
          [_vModelText, _unref(wkl).id]
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("Study.Comments")), 1),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(wkl).clinicaldata) = $event))
        }, null, 512), [
          [_vModelText, _unref(wkl).clinicaldata]
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("Study.ID")), 1),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(wkl).patid) = $event))
        }, null, 512), [
          [_vModelText, _unref(wkl).patid]
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t("Study.Name")), 1),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(wkl).patname) = $event))
        }, null, 512), [
          [_vModelText, _unref(wkl).patname]
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t("Study.BD")), 1),
        _withDirectives(_createElementVNode("input", {
          type: "date",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(wkl).patbd) = $event))
        }, null, 512), [
          [_vModelText, _unref(wkl).patbd]
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t("Study.Sex")), 1),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(wkl).patsex) = $event))
        }, _hoisted_17, 512), [
          [_vModelSelect, _unref(wkl).patsex]
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t("Worklist.StartDate")), 1),
        _withDirectives(_createElementVNode("input", {
          type: "date",
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(wkl).date) = $event))
        }, null, 512), [
          [_vModelText, _unref(wkl).date]
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t("Worklist.StartTime")), 1),
        _withDirectives(_createElementVNode("input", {
          type: "time",
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(wkl).starttime) = $event))
        }, null, 512), [
          [_vModelText, _unref(wkl).starttime]
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t("Study.Modality")), 1),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(wkl).modality) = $event))
        }, _hoisted_38, 512), [
          [_vModelSelect, _unref(wkl).modality]
        ])
      ]),
      _createElementVNode("div", _hoisted_39, [
        _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.$t("Study.Description")), 1),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(wkl).descr) = $event))
        }, null, 512), [
          [_vModelText, _unref(wkl).descr]
        ])
      ]),
      _createElementVNode("div", _hoisted_41, [
        _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.$t("Study.Status")), 1),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(wkl).status) = $event))
        }, _hoisted_47, 512), [
          [_vModelSelect, _unref(wkl).status]
        ])
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})